export const LOCAL_STORAGE_KEYS = {
	searches: "medic-finder:searches",
};
